module.exports = __webpack_public_path__ + "static/media/mad.static.ee44419d.svg";